import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_EMBEDDED_FILTERS = defineFcm('psf_embedded_filters')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				title: { type: 'string' },
				description: { type: 'string' },
				filter_options: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							id: { type: 'number' },
							label: { type: 'string' },
							emoji: { type: 'string' },
						},
					},
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		title: '',
		description: '',
		filter_options: [],
	})
	.toConfig({
		owner: 'squad-chameleon',
		scope: 'corgi-front-end',
		context: 'PSF embedded filters',
		description: 'Feature config for PSF embedded filters experiment (Topic Selection R3)',
		import: false,
		template: {
			enabled: false,
			title: '',
			description: '',
			filter_options: [],
		},
	});
